/**
 * @classdesc config情報Model
 * @export
 * @class SsConfig
 */
export class SsConfig {
  types?: any;
}
